import { render, staticRenderFns } from "./Dwelltime.vue?vue&type=template&id=3a3a1905&scoped=true"
import script from "./Dwelltime.vue?vue&type=script&lang=js"
export * from "./Dwelltime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3a1905",
  null
  
)

export default component.exports